import separateThousands from './separateThousands';

/**
 * formatPriceRange
 * @param {number|string|null|undefined} minCostValue
 * @param {number|string|null|undefined} maxCostValue
 * @param {string} [currency]
 * @returns {string} - formatted price text or empty string when not applicable
 */
export default function formatPriceRange(minCostValue, maxCostValue, currency) {
  const formatNumber = (v) => {
    if (v === null || v === undefined) return null;
    const num = Number(v);
    if (Number.isNaN(num)) return String(v);
    return separateThousands(num, ' ');
  };

  const minStr = formatNumber(minCostValue);
  const maxStr = formatNumber(maxCostValue);
  const currencyLabel = typeof currency === 'string' ? currency : '';
  const isZero = (s) => s === '0';

  let priceText = '';
  if (minStr !== null && maxStr !== null) {
    if (minStr === maxStr) {
      priceText = isZero(minStr) ? '' : `${minStr}`;
    } else {
      priceText = `${minStr} - ${maxStr}`;
    }
  } else if (minStr !== null) {
    priceText = isZero(minStr) ? '' : `${minStr}`;
  } else if (maxStr !== null) {
    priceText = isZero(maxStr) ? '' : `${maxStr}`;
  }

  if (!priceText) return '';
  return currencyLabel ? `${priceText} ${currencyLabel}` : priceText;
}
